import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import LoginContentStep1 from '../../../core/components/login/LoginContentStep1';
import LoginContentStep2 from '../../../core/components/login/LoginContentStep2';
import LoginContentStep3 from '../../../core/components/login/LoginContentStep3';
import { selectLoginModalStep } from '../../selectors/sell-tickets';
import { setLoginModalStep } from '../../actions/sell-tickets';
import { selectAuth } from '../../../core/selectors/auth';
import { LOGIN_STEP_1, LOGIN_STEP_2, LOGIN_STEP_3 } from '../../constants/modal';

const LoginModalContent = ({ goToNextStep, targetPath }) => {
    const step = useSelector(selectLoginModalStep);
    const auth = useSelector(selectAuth);
    return (getModalContent(step, auth, goToNextStep, targetPath));
};
const getModalContent = (step, auth, goToNextStep, targetPath) => {
    const dispatch = useDispatch();
    switch (step) {
        case LOGIN_STEP_1:
            return <LoginLayout goToStep={() => dispatch(setLoginModalStep(null))}>
                <LoginContentStep1 auth={auth} targetPath={targetPath}/>
            </LoginLayout>;
        case LOGIN_STEP_2:
            return <LoginLayout goToStep={() => dispatch(setLoginModalStep(LOGIN_STEP_1))}>
                <LoginContentStep2 auth={auth} goToNextStep={goToNextStep}/>
            </LoginLayout>;
        case LOGIN_STEP_3:
        default:
            return <LoginLayoutStep3><LoginContentStep3 targetPath={targetPath}/></LoginLayoutStep3>;
    }
};
const LoginLayout = ({ children, goToStep }) => (
    <div className="login-container">
        <h3 className="mb-0">
            <span className="me-2" onClick={goToStep}>
                <i className="bi bi-arrow-left cursor-pointer"></i>
            </span> <FormattedMessage id="login"/></h3>
        <p className="mb-5"><FormattedMessage id="connect_modal_subtitle"/></p>
        {children}
    </div>
);
const LoginLayoutStep3 = ({ children }) => (
    <div className="login-container">
        <h3 className="mb-0"><FormattedMessage id='authentication'/></h3>
        <p className="mb-4"><FormattedMessage id='connect_modal_subtitle'/></p>
        {children}
    </div>);
export default LoginModalContent;
